import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

import slide1 from "../assets/contactless_water_dispenser.png";
import slide2 from "../assets/smart_dustbin_dashboard.png";
import slide3 from "../assets/smart_dustbin.png";


const ImageSlider = () => {
  return (
    <div style={{ width: "100%", maxWidth: "1200px", margin: "50px auto" }}>
      <Swiper
        modules={[Autoplay, Navigation, Pagination]}
        spaceBetween={20}          // spacing between slides
        slidesPerView={1}
        loop={true}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000 }}
        style={{ borderRadius: "12px", overflow: "hidden" }} // rounded edges
      >
        <SwiperSlide>
          <img
            src={slide1}
            alt="Slide 1"
            style={{
              width: "100%",
              height: "500px",        // professional height
              objectFit: "cover",      // maintain aspect ratio
              borderRadius: "12px"
            }}
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={slide2}
            alt="Slide 2"
            style={{
              width: "100%",
              height: "500px",        // same height for uniformity
              objectFit: "cover",
              borderRadius: "12px"
            }}
          />
        </SwiperSlide>

         <SwiperSlide>
          <img
            src={slide3}
            alt="Slide 3"
            style={{
              width: "100%",
              height: "500px",        // same height for uniformity
              objectFit: "cover",
              borderRadius: "12px"
            }}
          />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default ImageSlider;
